/**
 * Header Language Selector
 * Custom language selector for header with link-style display
 */

class HeaderLanguageSelector {
  constructor() {
    this.init();
  }

  init() {
    const languageLinks = document.querySelectorAll('.js-header-language-link');
    const mobileLanguageLinks = document.querySelectorAll('.js-mobile-language-link');
    
    if (languageLinks.length === 0 && mobileLanguageLinks.length === 0) return;

    languageLinks.forEach(link => {
      link.addEventListener('click', this.handleLanguageChange.bind(this));
    });

    mobileLanguageLinks.forEach(link => {
      link.addEventListener('click', this.handleMobileLanguageChange.bind(this));
    });
  }

  handleLanguageChange(event) {
    event.preventDefault();
    
    const languageCode = event.currentTarget.dataset.languageCode;
    const form = document.querySelector('#header-localization-form');
    
    if (!form || !languageCode) return;
    
    // Update the hidden input value
    const localeInput = form.querySelector('input[name="locale_code"]');
    if (localeInput) {
      localeInput.value = languageCode;
    }
    
    // Submit the form
    form.submit();
  }

  handleMobileLanguageChange(event) {
    event.preventDefault();
    
    const languageCode = event.currentTarget.dataset.languageCode;
    const form = document.querySelector('#mobile-localization-form');
    
    if (!form || !languageCode) return;
    
    // Update the hidden input value
    const localeInput = form.querySelector('input[name="locale_code"]');
    if (localeInput) {
      localeInput.value = languageCode;
    }
    
    // Submit the form
    form.submit();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new HeaderLanguageSelector();
});
